<div class="desktop-shadow-card about-card">


  <!-- Story of the fundraiser -->
  <section class="about-effect">
    <app-fr-card>
      <!-- Appeal box -->
      <div class="appeal-box" *ngIf="fundraiser?.support_campaign">
        <div class="head-section">
          <h1>
            <i class="material-icons"> campaign </i>
            Appeal
          </h1>
          <span class="float-right edit" (click)="editAppeal(edit)" *ngIf="checkOwner()">
            Edit
            <i class="material-icons">
              edit
            </i>
          </span>
        </div>
        <div class="campaigner-box-wrapper">
          <div class="campaigner-top-box">
            <div class="img-container" *ngIf="!fundraiser?.support_campaign?.entity?.avtar && !fundraiser?.support_campaign?.entity?.avtar?.cdn_path">
              <span class="img-placeholder">{{entity.initials| uppercase}}</span>
            </div>
            <img loading="lazy"
              *ngIf="fundraiser.support_campaign.entity.avtar && fundraiser.support_campaign.entity.avtar.cdn_path"
              [src]="fundraiser.support_campaign.entity.avtar.cdn_path"
              alt=""
              class="rounded-img"
            />
            <div class="name">{{fundraiser.support_campaign.entity.full_name}}</div>
          </div>
          <div class="comments">
            <img loading="lazy"
              src="assets/images/homepage/quote-left-dark.svg"
              alt=""
              srcset=""
            />
            <span>
              {{fundraiser.support_campaign.appeal}}
            </span>
          </div>
        </div>
      </div>
      <div #aboutContainer class="about-container">
        <div class="about-heading">About the Fundraiser</div>
        <app-inner-templater [innerHtml]="about"></app-inner-templater>
        <app-fb-share *ngIf="!isPreview" class="fr-ended-share d-sm-none" [campaign_url]="campaignUrl" label="Inspire with this story" [count]="sharedCounts?.fb" [position]="7"></app-fb-share>
      </div>
      <div #showMore class="about-show-more">
        <button *ngIf="updates || !isShown" class="about-show-btn" mat-raised-button (click)="toggleClass()" >
          {{isShown?'Read Latest Updates':'Read More'}}
        </button>
      </div>
    </app-fr-card>
  </section>
  <!-- Medical Documents -->
  <div *ngIf="(fundraiser?.viewmedicalbill?.length || fundraiser?.count_medical_bill) && (!isFundraiserEnded || vars?.fundraiser?.isDonated)">
    <mat-card class="fr-document">
      <mat-card-header class="header">
        <mat-card-title class="title">{{vars.showKCart ? '' : 'Medical'}} Documents</mat-card-title>
      </mat-card-header>
      <div *ngIf="fundraiser?.count_medical_bill && !fundraiser?.viewmedicalbill?.length" class="med-doc-place-holder">
        <app-component-loader [load]="true" selector="app-med-doc-place-holder"
          [inputs]="{position: 'about', fundraiser: fundraiser}"
        />
      </div>
      <div *ngIf="fundraiser?.viewmedicalbill?.length" class="doc-wrapper">
        <app-img-slider [swiperconfig]="docsSlideConfig" [showNavs]="isMobile ? true : false" [showOuterNavs]="isMobile ? false : true" [gallery]="fundraiser?.viewmedicalbill" slideType="docs" [hasThumbs]="false" position="medical-doc-about"></app-img-slider>
      </div>
    </mat-card>
  </div>
  <div class="d-none d-sm-block">
    <div class="social-share" [ngClass]="{'full-Width': isFundraiserEnded}" *ngIf="!isPreview">
      <app-whatsapp-share class="fr-ended-share"
                          label="Share" [count]="sharedCounts?.whatsapp" [fundraiser]="fundraiser"
                          [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo" [position]="3">
      </app-whatsapp-share>
      <app-fb-share class="fr-ended-share" [campaign_url]="campaignUrl" label="Share" [count]="sharedCounts?.fb" [position]="3"></app-fb-share>
      <app-donate-now *ngIf="!isFundraiserEnded" [label]="donateBtnLabel" [position]="3" [fundraiser]="fundraiser"></app-donate-now>
    </div>
  </div>
</div>

<!-- Donation Methods -->
<div *ngIf="!isFundraiserEnded && currency=='INR' && (fundraiser?.banktransfer?.info_3 || fundraiser?.settings?.show_qr) && !isPreview" class="desktop-shadow-card">
  <app-donation-methods [donateBtnLabel]="donateBtnLabel" [fundraiser]="fundraiser"
                        [bank]="fundraiser?.banktransfer" origin="f">
  </app-donation-methods>
</div>

<div class="desktop-shadow-card refer-friend" *ngIf="!isPreview">
  <!--Refer a Friend module-->
  <app-refer-friend></app-refer-friend>
</div>

<!-- Supporting Fundraiser Card -->
<app-supporting-fr-card *ngIf="fundraiser && isMobile && !fundraiser?.support_campaign && (!isFundraiserEnded || vars?.fundraiser?.isDonated) && !isPreview" [fundraiser]="fundraiser" [currency]="currency" [isFundraiserEnded]="isFundraiserEnded"></app-supporting-fr-card>

<!-- Top donors in varies category list -->
<div *ngIf="!isLoggedIn && vars.mandateLoginCheck && !fundraiser?.settings?.nodonorlist && isMobile && (!isFundraiserEnded || vars?.fundraiser?.isDonated) && !isPreview" class="donors-list">
  <app-component-loader [load]="true" selector="app-supporters-place-holder"
    [inputs]="{position: 'supporters', fundraiser: fundraiser}"
  />
</div>
<div *ngIf="isLoggedIn || !vars.mandateLoginCheck" class="donors-list">
  <app-supporter *ngIf="!fundraiser?.settings?.nodonorlist && isMobile && (!isFundraiserEnded || vars?.fundraiser?.isDonated) && !isPreview" [isFundraiserEnded]="isFundraiserEnded"
                [isLoading]="isLoading" [donateBtnLabel]="donateBtnLabel" [supporters]="supporters"
                [settings]="fundraiser?.settings" [fundraiser]="fundraiser">
  </app-supporter>
</div>

<div class="desktop-shadow-card" *ngIf="!isPreview">
    <div class="section-title">
      <span class="title-text">Supporters’ Comments <span *ngIf="checkLength(comments?.data)">({{comments?.total}})</span></span>
    </div>
  <!-- Comments card -->
  <app-comment-card [comments]="comments" origin="campaign" [postCommentLabel]="'Write something to cheer '+fundraiser?.campaigner?.fname"
                  [campaignId]="fundraiser?.id" [customTag]="fundraiser?.custom_tag" [tabSwitch]="true">
  </app-comment-card>
</div>


<ng-template #edit>
  <div class="sfSumitted-container">
    <button class="close" (click)="closeDialog()" mat-icon-button>
      <i class="material-icons">close</i>
    </button>
    <h3 class="header">
      Edit Details
    </h3>
    <div class="form">
      <form class="edit-form" [formGroup]="editForm" (ngSubmit)="editFormSubmit()">
        <span class="label">Appeal</span>
          <textarea placeholder="Make an Appeal.." [formControl]="appeal" name="appeal" class="appeal-textarea" (input)="checkError()"></textarea>
          <mat-error *ngIf="appeal.hasError('required') && appeal.touched">Field required</mat-error>
          <mat-error *ngIf="appeal.hasError('minlength') && appeal.touched">{{formInfo?.appeal?.error?.minlength}}</mat-error>
        <button id="submitBtn3" style="display: none" ></button>
      </form>
      <button mat-raised-button type="submit" class="save-btn" color="primary" (click)="submitButton()" [disabled]="isLoading || !this.editForm.valid">
        <div class="button-wrapper" *ngIf="!isLoading">
          SAVE
        </div>
        <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </div>
  </div>
</ng-template>
